module.exports = __webpack_public_path__ + "img/m_common_banner.ae713754.png";